export enum AbsenceType {
  SickDay = "SickDay",
  ChildCare = "ChildCare",
  Vaccation = "Vaccation",
  Other = "Other",
  None = "None"
}
